// extracted by mini-css-extract-plugin
export default {"Document":"base-pdf-viewer_Document__xaqU1","PdfToolbar":"base-pdf-viewer_PdfToolbar__ZhHIN","LoadingPDF":"base-pdf-viewer_LoadingPDF__Sqz83"};